import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";

export default function UpdatePopIqama({
  popUpOpen,
  setPopUpOpen,
  propData,
  callBack,
}) {
  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };
  const [date, SetDate] = useState("");
  const [dateH, setDateH] = useState("");
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      if (date === "" || dateH === "") {
        dispatch(
          setAppError({
            msg: "Iqama Expiry Date is required.",
          })
        );
        return;
      }

      const employeeIDS = propData.map((data, index) => data.emp_id);
      const reqObj = {
        employee_id: employeeIDS,
        ExpiryDateG: date,
        ExpiryDateH: dateH,
      };
      console.log("propData to be seen in the console", reqObj);
      const response = await nodeinstance.put(
        `/iqama/UpdateIqamaExpiry`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("response to be printed in the console", response);
        setPopUpOpen(false);
        callBack();
      }
    } catch (error) {
      console.log("error to be seen in the console", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          popUpOpen ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUpOpen(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5 text-center">
              <div className="form-control w-full text-center gap-2">
                {/* <span className="label-text  text-xl text-center">{title}</span> */}
              </div>

              <div className="flex flex-col items-center justify-center gap-2 place-items-center">
                <label className="text-sm">Update Iqama Expiry(G)</label>
                <input
                  type="date"
                  onKeyDown={handleKeyDown}
                  id="field2"
                  className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                  required
                  onChange={(e) => SetDate(e.target.value)}
                />
              </div>

              <div className="flex flex-col items-center justify-center gap-2 place-items-center">
                <label className="text-sm">Update Iqama Expiry(H)</label>
                <input
                  // type="date"
                  // onKeyDown={handleKeyDown}
                  id="field2"
                  className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                  required
                  onChange={(e) => setDateH(e.target.value)}
                />
              </div>

              <div
                className="flex gap-3 w-full justify-center"
                style={{ margin: 2 }}
              >
                <button
                  type="submit"
                  className="p-3 bg-green-500 text-white rounded-md w-full max-w-48  my-4 flex  justify-center items-center text-sm"
                  onClick={() => {
                    // setLoading(true);
                    onSubmit();
                  }}
                >
                  <p>Proceed </p>
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
          </div>
          {/* <label>error</label> */}
        </div>
      </div>
    </>
  );
}
